/**
 * ToTheLove — Le calcul : scroll smooth vers le buy box (JS pur, sans # dans l’URL).
 */
(function () {
  if (window.__ttlCalculScroll) return;
  window.__ttlCalculScroll = true;

  function headerOffset() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var n = parseFloat(raw);
    return Number.isFinite(n) && n > 0 ? n : 56;
  }

  function resolveTarget(id) {
    if (id) {
      var byId = document.getElementById(id);
      if (byId) return byId;
    }
    return (
      document.querySelector('[data-ttl-buybox]') ||
      document.getElementById('ttl-buybox') ||
      document.querySelector('[id^="ProductInfo-"]') ||
      document.querySelector('product-info') ||
      document.getElementById('MainContent')
    );
  }

  function scrollToTarget(target) {
    if (!target) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  }

  function targetIdFromEl(el) {
    if (!el) return 'ttl-buybox';
    var raw =
      el.getAttribute('data-ttl-scroll-to') ||
      el.getAttribute('href') ||
      'ttl-buybox';
    raw = String(raw).replace(/^#/, '').trim();
    if (!raw || raw === 'ProductInfo-main') return 'ttl-buybox';
    return raw;
  }

  document.addEventListener(
    'click',
    function (event) {
      var el =
        event.target &&
        event.target.closest &&
        event.target.closest('[data-ttl-scroll-to], a.ttl-calcul__btn, button.ttl-calcul__btn');
      if (!el) return;
      event.preventDefault();
      event.stopPropagation();
      scrollToTarget(resolveTarget(targetIdFromEl(el)));
    },
    true
  );
})();

